```vue
<template>
  <section class="collection">

    <!-- Section Header -->
    <div class="collection-header">

      <h2>
        {{ title }}
      </h2>

      <button
        class="view-all-btn"
        @click="$emit('view-all')"
      >
        View All
        <span>→</span>
      </button>

    </div>


    <!-- Books Row -->
    <div class="books-row">

      <div
        v-for="book in books"
        :key="
          book.id ||
          book.ISBN
        "
        class="book-item"
      >

        <BookCard
          :book="book"
          :wishlist="$store.state.wishlist"
        />

      </div>

    </div>

  </section>
</template>


<script>

import BookCard
  from '../BookCard/BookCard.vue'


export default {

  name: 'BookCollection',


  components: {
    BookCard
  },


  props: {

    title: {
      type: String,
      required: true
    },


    books: {
      type: Array,
      required: true
    }

  }

}

</script>


<style scoped>

.collection {
  width: 100%;
}


/* Header */

.collection-header {
  display: flex;

  justify-content: space-between;

  align-items: center;

  margin-bottom: 22px;

  padding-bottom: 12px;

  border-bottom:
    1px solid var(--border);
}


.collection-header h2 {
  margin: 0;

  color: var(--text);

  font-size: 1.65rem;

  font-weight: 800;
}


.view-all-btn {
  border: none;

  background: transparent;

  color: var(--primary);

  font-weight: 700;

  font-size: 0.9rem;

  cursor: pointer;

  transition:
    transform 0.2s ease;
}


.view-all-btn span {
  margin-left: 5px;

  transition:
    margin-left 0.2s ease;
}


.view-all-btn:hover {
  transform:
    translateX(2px);
}


.view-all-btn:hover span {
  margin-left: 9px;
}


/* Books */

.books-row {
  display: grid;

  grid-template-columns:
    repeat(4, 1fr);

  gap: 22px;
}


.book-item {
  min-width: 0;
}


/* Remove Bootstrap column spacing */

.book-item :deep(.col) {
  width: 100%;

  padding: 0;
}


@media (max-width: 992px) {

  .books-row {
    grid-template-columns:
      repeat(3, 1fr);
  }

}


@media (max-width: 768px) {

  .books-row {
    grid-template-columns:
      repeat(2, 1fr);

    gap: 15px;
  }

}


@media (max-width: 500px) {

  .books-row {
    grid-template-columns:
      1fr;
  }

}

</style>
```
